// RoleContext.js
import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { secretKey } from 'src/constants/secret';

export const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [userId, setUserId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);

  useEffect(() => {
    const decodeToken = () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decodedToken = jwtDecode(token, secretKey);
          setRole(decodedToken.role);
          localStorage.setItem('username', decodedToken.user_id);
          setUserId(decodedToken.user_id);
          setSchoolId(decodedToken.user_id.match(/\d+/));
        } catch (error) {
          console.error('Failed to decode token:', error);
        }
      }
    };

    decodeToken();
  }, []);

  return (
    <RoleContext.Provider
      value={{ role, userId, setRole, setUserId, schoolId }}
    >
      {children}
    </RoleContext.Provider>
  );
};
